export default "__VITE_ASSET__CAaobWK6__"